import { i18n } from 'translations/i18n';

export const getLanguageDirection = (language: string) => {
  return i18n.dir(language.replace('_', '-'));
};
